//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import { imageHandler } from "helpers/imageHandler";
import Grid from "@material-ui/core/Grid";


// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
// material-ui icons

const ReviewTextField = withStyles({
  root: {
    width: "30%",
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#1473e6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1473e6",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 5,
        padding: "12px 16px !important",
        fontSize: "14px !important",
        lineHeight: "22px",
        color: "#0f1d40",
      },
    },
  },
})(TextField);

export default function EnrollmentAdminConsent() {
  const { getAdminConsentStatus, verifyAdminConsent } = auth();
  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const source = param.get("from"); 
  const isFromEmail = source === "email";

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [usLink, setusLink] = useState("");
  const [caLink, setcaLink] = useState("");
  const [frLink, setfrLink] = useState("");
  const [emailMessage, setemailMessage] = useState(false);
  const [emailMessageValue, setemailMessageValue] = useState('');
  const [redirectionEmail, setRedirectionEmail] = useState({});



  
  const [data, setData] = useState({});
  const [loginToken, setLoginToken] = useState("");

  useEffect(() => {
    handleGetAdminConsentStatus();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(param.get("lang"));
  }, []);

  // Get Admin Consent Status and handle auto-confirm if from email and US
  const handleGetAdminConsentStatus = async () => {
    try {
      setLoading(true);
      let res = await getAdminConsentStatus(token);

      if (res && res?.type === "success") {
        const lang = param.get("lang");
        setStatus(res?.status);
        setMessage(lang === "fr" ? res?.french_message : res?.message);
        if(res?.status=='Processed' && isFromEmail && res?.db === "US"){
          setemailMessageValue(true)
          setemailMessage(res?.emailmessage)
          setRedirectionEmail(res?.redirectionLinks)
        

        }
        setData(res);
        setusLink(res?.usLink);
        setcaLink(res?.caLink);
        setfrLink(res?.frLink);
        setLoginToken(res?.token);

        if (isFromEmail && res?.db === "US" && res?.status === "Inprocessed") {
          await handleAdminConsent(res);
          return;
        }

        setLoading(false);
        return;
      }

      if (res?.message?.toLowerCase().includes("expired")) {
        setStatus("Expired");
        setMessage("Your link has expired");
      } else {
        setStatus("Unauthorized");
        setMessage(param.get("lang") === "fr" ? res?.french_message : res?.message || "Unauthorized");
      }

      setLoading(false);
    } catch (e) {
      console.log("Error:", e);
      setMessage("Something went wrong.");
      setStatus("Unauthorized");
      setLoading(false);
    }
  };

  const handleAdminConsent = async (initialData) => {
    try {
      const login = location.state && location.state.login;

      let values = {
        loyalty_id: (initialData || data)?.loyalty_id,
        customer_billto_account_number: (initialData || data)?.customer_billto_account_number,
        user: (initialData || data)?.user,
        DATABASE: (initialData || data)?.db,
        token: token,
      };

      setLoading(true);
      const res = await verifyAdminConsent(values);
      setLoading(false);

      if (res?.type === "success") {
        setMessage(param.get("lang") === "fr" ? res?.french_message : res?.message);
        setStatus("Processed");
        setLoginToken(res?.token);
      } else {
        setStatus("Unauthorized");
        setMessage(res?.message || "Something went wrong");
      }
    } catch (e) {
      console.log("Admin consent error:", e);
      setStatus("Unauthorized");
      setMessage("Something went wrong.");
      setLoading(false);
    }
  };

  const handleClose = async () => {
    try {
      window.close();
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <img
        src={
          imageHandler?.[data?.db === "US" ? "Henry Schein Dental" : "Henry Schein Canada"]
            ?. [i18n?.language]
            ?. [data?.db === "US" ? "Newheader" : "nullHeaderLogo"]
        }
        alt="logo"
        style={{ marginTop: 50, marginBottom: 50, width: 400 }}
      />
      <Loader Loading={loading}>
        {status === "Inprocessed" && !isFromEmail && (
          <Card className={classes.card}>
            <div className={classes.divText}>{t("Acknowledgement")}</div>
            <div className={classes.divSubText}>
              {t("Thrive Rewards is a discount program intended for private dental practice and small group practices")}.{" "}
              {data?.db === "US"
                ? t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-888-6684")
                : t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-668-5558")}.{" "}
              {t("By enrolling in Thrive Rewards, you have read, understood and agree to the")}{" "}
              {data?.db === "US" ? (
                <a target="_blank" href={usLink} rel="noreferrer">
                  {t("[Terms & Conditions]")}
                </a>
              ) : param?.get("lang") === "fr" ? (
                <a target="_blank" href={frLink} rel="noreferrer">
                  {t("[Terms & Conditions]")}
                </a>
              ) : (
                <a target="_blank" href={caLink} rel="noreferrer">
                  {t("[Terms & Conditions]")}
                </a>
              )}{" "}
              {t("of this program")}.
            </div>
            <div className={classes.divSubText}>
              <Grid container spacing={2}>
                <Grid xs={6}>
                  {t("Member ID")}: <br />
                  {data?.loyalty_id}
                </Grid>
                <Grid xs={6} style={{ textAlign: "right" }}>
                  {t("Billing Account")}: <br />
                  {data?.customer_billto_account_number}
                </Grid>
              </Grid>
            </div>
            <Button className={classes.cancelBtn} onClick={handleClose}>
              {t("Cancel Enrollment")}
            </Button>
            <Button className={classes.enrollBtn} onClick={() => handleAdminConsent()}>
              {t("Confirm Enrollment")}
            </Button>
          </Card>
        )}

        {(status === "Processed" &&!emailMessageValue) && (
          <div>
            <img
              src={
                imageHandler?.[data?.db === "US" ? "Henry Schein Dental" : "Henry Schein Canada"]
                  ?. [i18n?.language]
                  ?. [data?.db === "US" ? "NewCongrulations" : "congratulationLogo"]
              }
              alt=""
              width="50%"
            />
            <div className={classes.message}>{message}</div>
            {location.state && location.state.login && loginToken && (
              <div>
                <Button
                  className={classes.viewMyDashboardBtn}
                  onClick={() => {
                    let redirectionUrl = `/dashboard/mydashboard?token=${loginToken}`;
                    window.location.replace(redirectionUrl);
                  }}
                >
                  {t("View My Dashboard")}
                </Button>
              </div>
            )}
          </div>
        )}
        {(status === "Processed" &&emailMessageValue) && (
          <div>
           
            <div className={classes.message}>{emailMessage}</div>
            <a
              target="_blank"
               href={param.get("lang") == "en" ? redirectionEmail['EMAIL_FOOTER_LINK_FIVE'] : redirectionEmail["EMAIL_FOOTER_LINK_FOUR"]}
              className={classes.ref}
            >
              {t(' Program Benefits |')}
            </a>
            <a
              target="_blank"
              href={param.get("lang") == "en" ? redirectionEmail['LEGAL_TERMS_CONDITIONS'] : redirectionEmail['LEGAL_TERMS_CONDITIONS_FR']}
              className={classes.ref}
            >
              {t(' Terms |')}
            </a>
             <a
              target="_blank"
               href={param.get("lang") == "en" ? redirectionEmail['CONTACT_SUPPORT']: redirectionEmail['CONTACT_SUPPORT']}
              className={classes.ref}
            >
              {t(' Contact Support')}
            </a>
            {location.state && location.state.login && loginToken && (
              <div>
                <Button
                  className={classes.viewMyDashboardBtn}
                  onClick={() => {
                    let redirectionUrl = `/dashboard/mydashboard?token=${loginToken}`;
                    window.location.replace(redirectionUrl);
                  }}
                >
                  {t("View My Dashboard")}
                </Button>
              </div>
            )}
          </div>
        )}

        {status === "Unauthorized" && (
          <div>
            <div className={classes.message}>{message}</div>
          </div>
        )}

        {status === "Expired" && (
          <div className={classes.message}>
            {message}
            <br />
          </div>
        )}
      </Loader>
    </div>
  );
}
